let APP_NAME = "ishopfood";
let CONFIG_TUNNEL_PATH = "C:/ishopfood/tunnel/config.json.dist";
let CONFIG_TUNNEL_CONTENT;

window.updating = false;
window.update = (options = {}) => {
  if (typeof nw == "undefined") {
    console.log("NOT IN NW");
    return;
  }
  if (window.updating) {
    console.log("already updating.");
    return;
  }
    _updateGetVersionNumber(options.force)
    .then(_updateFetchLastVersionNumber)
    .then(_updateDownload)
    .then(_updateApply)
    .catch((e) => {
      hideSpinner();
      _updateError(e);
    });
};

// urlUpdate may be http (legacy S3 bucket) or https (CloudFront channel); Node's http.get rejects https URLs.
let _updateHttpGet = (url, callback) => {
  let client = url.startsWith("https:") ? nw.require("https") : nw.require("http");
  return client.get(url, callback);
};

// S3 answers 403/404 with an XML body: never treat it as a version number or a zip.
let _updateCheckStatus = (url, response) => {
  if (response.statusCode !== 200) {
    response.resume();
    return new Error("HTTP " + response.statusCode + " on " + url);
  }
  return null;
};


let _updateGetVersionNumber = (force) => {
  return new Promise(function(resolve, reject) {
    let fs = nw.require("fs");
    let currentVersion = "0.0.0";
    if (fs.existsSync("versionNumber.txt")) {
      currentVersion = fs.readFileSync("versionNumber.txt", "utf8");
    }
    currentVersion = currentVersion.split(".").map(i => parseInt(i));
    resolve({currentVersion, force});
  });
};

let _updateFetchLastVersionNumber = function({currentVersion, force}) {
  return new Promise((resolve, reject) => {
    let fs = nw.require("fs");
    let url = Parameters.urlUpdate + "/versionNumber.txt";
    _updateHttpGet(url, function(response) {
      let statusError = _updateCheckStatus(url, response);
      if (statusError) {
        logToFile(statusError.message);
        reject(statusError);
        return;
      }
      let newVersion = "";

      response.on("data", (chunk) => {
        newVersion += chunk;
      });

      response.on("end", () => {
        newVersion = newVersion.split(".").map(i => parseInt(i));
        console.log("current version is " + currentVersion + ", new version is " + newVersion);
        logToFile("current version is " + currentVersion + ", new version is " + newVersion);
        let updateAvailable = newVersion[0] > currentVersion[0]
          || (newVersion[0] == currentVersion[0] && newVersion[1] > currentVersion[1])
          || (newVersion[0] == currentVersion[0] && newVersion[1] == currentVersion[1] && newVersion[2] > currentVersion[2]);

        if (updateAvailable) {
          fs.readFile("versionHistory.txt", "utf8", (err, data) => {
            let versionHistory = parseVersionHistory(data);

            let changelogText = "";
            changelogText += "<div style='text-align: left; margin-top: 20px; overflow-y: auto; max-height: 400px;'>"

            for (let version in versionHistory) {
              let split = version.split(".").map(n => parseInt(n));
              if (split.join(".") == currentVersion.join(".") || split[0] < currentVersion[0]
                || (split[0] == currentVersion[0] && split[1] < currentVersion[1]
                  || (split[0] == currentVersion[0] && split[1] == currentVersion[1] && split[2] < currentVersion[2]))) {
                break;
              }
              changelogText += "<div style='font-weight: bold'>Version " + version + "</div>";
              changelogText += "<ul style='margin: 0'>";
              for (let line of versionHistory[version]) {
                changelogText += "<li>" + line.replace(/^-/, "") + "</li>"
              }
              changelogText += "</ul>";
            }
            changelogText += "</div>";

            if (!force) {
              showConfirmation(window.translate("download.update"), window.translate("download.update_text") + changelogText)
                .then((response) => {
                  if (response) {
                    resolve(newVersion);
                  }
                });
            } else {
              resolve(newVersion);
            }
          })
        } else {
          showAffirmation(window.translate("download.last_version"), window.translate("download.you_have_last_version"));
        }
      }).on("error", (e) => {
        reject(e);
      });
    }).on("error", (e) => {
      reject(e);
    });
  });
};

let _updateDownload = (newVersion) => {
  return new Promise((resolve, reject) => {
    window.updating = true;

    let fs = nw.require("fs");

    let url = Parameters.urlUpdate + "/zip/" + APP_NAME + "-" + newVersion.join(".") + ".zip";
    console.log(url);
    _updateHttpGet(url, (response) => {

      console.log(response);
      let statusError = _updateCheckStatus(url, response);
      if (statusError) {
        logToFile(statusError.message);
        window.updating = false;
        reject(statusError);
        return;
      }

      let totalLength = parseInt(response.headers["content-length"]);
      if (totalLength <= 100) {
        showAffirmation(window.translate("error.title"), window.translate("download.cannot_be_downloaded"));
        return;
      }
      let downloaded = 0;
      let file = fs.createWriteStream("update.zip");

      document.getElementById("modalUpdateDownload").classList.add("show");
      document.querySelector("#modalUpdateDownload .modal-header").innerHTML = window.translate("download.downloading") + "...";
      document.querySelector("#modalUpdateDownload .current").innerHTML = "0.00";
      document.querySelector("#modalUpdateDownload .total").innerHTML = (totalLength / 1000000).toFixed(2);
      document.querySelector("#modalUpdateDownload .progressBar .inner").style.width = "0";

      response
        .on("data", (chunk) => {
          downloaded += chunk.length;
          document.querySelector("#modalUpdateDownload .current").innerHTML = (downloaded / 1000000).toFixed(2);
          document.querySelector("#modalUpdateDownload .progressBar .inner").style.width = (downloaded / totalLength * 100) + "%";
          file.write(chunk);
        })
        .on("end", () => {
          file.end();
          resolve();
        })
        .on("error", (e) => {
          window.updating = false;
          reject(e);
        });
      })
      .on("error", (e) => {
        window.updating = false;
        reject(e);
      });

  });
};

let _updateApply = () => {
  return new Promise((resolve, reject) => {
    let unzip = nw.require("unzipper");
    let fs = nw.require("fs");

    document.querySelector("#modalUpdateDownload .modal-header").innerHTML = window.translate("download.installing") + "...";
    fs.createReadStream("update.zip")
      .pipe(unzip.Extract({path: "update"}))
      .on("close", () => {
        fs.unlink("update.zip", err => {
          console.log(err);
        });
        document.getElementById("modalUpdateDownload").classList.remove("show");
        showAffirmation(window.translate("download.done"), window.translate("download.update_done"))
            .then(() => {
              let child_process = nw.require("child_process");
              let child = child_process.spawn("update.bat", [], {detached: true, shell: true});
              child.unref();
              nw.App.quit();
            });

        resolve();
      })
      .on("error", (e) => {
        window.updating = false;
        reject(e);
      });
  });
};

let _updateError = (e) => {
  console.log(e);
  document.getElementById("modalUpdateDownload").classList.remove("show");
  showAffirmation(window.translate("error.title"), window.translate("download.error"));
};

let parseVersionHistory = (data) => {
  let split = data.split("\n").map(s => s.trim()).filter(s => s.length > 0);
  let currentVersion = null;
  let toReturn = {};

  for (let line of split) {
    if (/[0-9]+\.[0-9]+\.[0-9]+/.test(line)) {
      currentVersion = line;
      toReturn[currentVersion] = [];
    } else {
      toReturn[currentVersion].push(line);
    }
  }

  return toReturn;
};
